import React, { useState } from "react";
import { MDBBtn as Button } from "mdb-react-ui-kit";
import Modal from "react-bootstrap/Modal";

function EmployeeEducationModal({ show, handleClose }) {
  const [educationData, setEducationData] = useState("");
  return (
    <Modal show={show} size="lg" onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Add Education Info</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            padding: "1%",
          }}
        >
          <div style={{ width: "30%" }}>School</div>
          <input style={{ width: "70%" }} />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            padding: "1%",
          }}
        >
          <div style={{ width: "30%" }}>Country</div>
          <input style={{ width: "70%" }} />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            padding: "1%",
          }}
        >
          <div style={{ width: "30%" }}>Degree</div>
          <input style={{ width: "70%" }} />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            padding: "1%",
          }}
        >
          <div style={{ width: "30%" }}>Major</div>
          <input style={{ width: "70%" }} />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            padding: "1%",
          }}
        >
          <div style={{ width: "30%" }}>Status</div>
          <input style={{ width: "70%" }} />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            padding: "1%",
          }}
        >
          <div style={{ width: "30%" }}>Competencies</div>
          <input style={{ width: "70%" }} />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            padding: "1%",
          }}
        >
          <div style={{ width: "30%" }}>Accomplishment</div>
          <input style={{ width: "70%" }} />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "end",
            width: "100%",
            padding: "1%",
          }}
        >
          <button
            style={{
              backgroundColor: "var(--primary)",
              color: "var(--light)",
              borderRadius: "10px",
              padding: "1.5%",
              border: "none",
            }}
          >
            Save
          </button>
          {/* <button
            style={{
              backgroundColor: "var(--light)",
              color: "var(--dark)",
              borderRadius: "10px",
              padding: "1.5%",
              border: "none",
              marginLeft: "2%",
            }}
          >
            Cancel
          </button> */}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default EmployeeEducationModal;
